import { get } from "lodash-es";

export const warrantyParser = (response) => {
    try {
        if (response?.result) {
            response = response.result;
        }
        if (!response) {
            return {
                results: [],
                count: 0,
                pageNo: 0,
                limit: 10,
                sortBy: "DESC",
                sortField: "created_at",
            };
        }
        if (response.data?.warranty_registrations) {
            response.results = response.data.warranty_registrations.map((row, key) => {
                return {
                    id: get(row, "id", ""),
                    registration_number: get(row, "registration_number", ""),
                    customer_name: get(row, "customer_name", ""),
                    email: get(row, "email", ""),
                    mobile: get(row, "mobile", ""),
                    address: get(row, "address", ""),
                    city: get(row, "city", ""),
                    state: get(row, "state", ""),
                    pincode: get(row, "pincode", ""),
                    purchase_date: get(row, "purchase_date", ""),
                    dealer_name: get(row, "dealer_name", ""),
                    dealer_state: get(row, "dealer_state", ""),
                    files: get(row, "files", []),
                    status: get(row, "status", "pending"),
                    approved_by: get(row, "approved_by", ""),
                    rejection_reason: get(row, "rejection_reason", ""),
                    created_at: get(row, "created_at", ""),
                    updated_at: get(row, "updated_at", ""),
                    product: {
                        id: get(row, "product.id", ""),
                        name: get(row, "product.name", ""),
                        description: get(row, "product.description", ""),
                        image_url: get(row, "product.image_url", ""),
                    },
                };
            });
            response.count = response.data.pagination?.total || 0;
        } else if (response.warranty_registrations) {
            response.results = response.warranty_registrations.map((row, key) => {
                return {
                    id: get(row, "id", ""),
                    registration_number: get(row, "registration_number", ""),
                    customer_name: get(row, "customer_name", ""),
                    email: get(row, "email", ""),
                    mobile: get(row, "mobile", ""),
                    address: get(row, "address", ""),
                    city: get(row, "city", ""),
                    state: get(row, "state", ""),
                    pincode: get(row, "pincode", ""),
                    purchase_date: get(row, "purchase_date", ""),
                    dealer_name: get(row, "dealer_name", ""),
                    dealer_state: get(row, "dealer_state", ""),
                    files: get(row, "files", []),
                    status: get(row, "status", "pending"),
                    approved_by: get(row, "approved_by", ""),
                    rejection_reason: get(row, "rejection_reason", ""),
                    created_at: get(row, "created_at", ""),
                    updated_at: get(row, "updated_at", ""),
                    product: {
                        id: get(row, "product.id", ""),
                        name: get(row, "product.name", ""),
                        description: get(row, "product.description", ""),
                        image_url: get(row, "product.image_url", ""),
                    },
                };
            });
            response.count = response.pagination?.total || 0;
        }

        return response;
    } catch (error) {
        throw new Error(error);
    }
};
